/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AtticLivableEnum = 1 | 2 | 3;

export const AtticLivableEnum = {
    NUMBER_1: 1 as AtticLivableEnum,
    NUMBER_2: 2 as AtticLivableEnum,
    NUMBER_3: 3 as AtticLivableEnum
};

